var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.items),function(item,itemIndex){return _c('li',{key:itemIndex,staticClass:"breadcrumb-item"},[_c('a',{on:{"click":function($event){return _vm.$changeRoute(item.to)}}},[_vm._v(_vm._s(item.text))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }